module.exports = __webpack_public_path__ + "static/media/selector_dot.337ee98c.svg";